import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyBuyBar() {
  const [scrolled, setScrolled] = useState(false);
  const [hideForSection, setHideForSection] = useState(false);
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/sistema-completo-de-ventas-en-amazon-fba-fbm-2026', '_blank', 'noopener,noreferrer');
  };
  // Show the bar once the user starts scrolling past the hero
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 500);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  // Hide the bar while the Sistema Completo section or the footer are in view
  useEffect(() => {
    const sistema = document.getElementById('sistema-completo');
    const footer = document.querySelector('footer');
    const watched = [sistema, footer].filter(Boolean) as Element[];
    if (watched.length === 0) return;
    const visibleSet = new Set<Element>();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) visibleSet.add(entry.target);else visibleSet.delete(entry.target);
      });
      setHideForSection(visibleSet.size > 0);
    }, {
      threshold: 0.15
    });
    watched.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  const visible = scrolled && !hideForSection;
  return <AnimatePresence data-id="element-868">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.28,
      ease: 'easeOut'
    }} className="md:hidden fixed bottom-0 inset-x-0 z-50 px-3 pb-[calc(env(safe-area-inset-bottom,0px)+0.6rem)] pt-2" data-id="element-869">
          <div className="bg-brand-white/95 backdrop-blur-md border border-brand-text/10 rounded-2xl shadow-[0_-6px_24px_-8px_rgba(0,0,0,0.18)] px-4 py-3 flex items-center gap-3" data-id="element-870">
            <div className="min-w-0 flex-1" data-id="element-871">
              <p className="text-[13px] font-semibold text-brand-green leading-tight truncate" data-id="element-872">
                Sistema Completo Amazon FBA + FBM
              </p>
              <div className="flex items-baseline gap-2 leading-none mt-0.5" data-id="element-873">
                <span className="text-lg font-bold text-brand-green" data-id="element-874">
                  $24.99 USD
                </span>
                <span className="text-xs font-semibold text-brand-green/70" data-id="element-875">
                  Ahorras $7.99
                </span>
              </div>
            </div>
            <button onClick={goToCheckout} className="flex-shrink-0 bg-brand-green hover:bg-brand-green/90 active:scale-[0.98] text-white text-sm font-bold px-5 py-3 rounded-xl shadow-lg shadow-brand-green/25 transition-all duration-150" data-id="element-876">
              COMPRAR AHORA
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}